import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Reveal } from "./Reveal";

export const CtaBand = () => (
  <section className="bg-white py-20 md:py-28" data-testid="cta-band">
    <div className="container-x">
      <div className="relative overflow-hidden rounded-[2rem] bg-[color:var(--navy)] px-6 py-14 md:px-16 md:py-20 grain">
        <div className="absolute -right-24 -top-24 h-80 w-80 rounded-full border-[40px] border-[color:var(--teal)]/30" aria-hidden="true" />
        <div className="relative grid gap-10 lg:grid-cols-12 lg:items-end">
          <Reveal className="lg:col-span-7">
            <p className="text-xs font-bold uppercase tracking-[0.18em] text-[#8FD3CE]">Nächster Schritt</p>
            <h2 className="mt-4 text-3xl md:text-5xl font-bold leading-tight tracking-tight text-white">
              Lassen Sie uns über Ihren <span className="font-serif-accent text-[#8FD3CE]">nächsten Schritt</span> sprechen.
            </h2>
          </Reveal>
          <Reveal delay={0.15} className="lg:col-span-5 flex flex-col sm:flex-row lg:flex-col xl:flex-row gap-3 lg:justify-end">
            <Link to="/personal-anfragen" data-testid="cta-band-inquiry" className="group inline-flex items-center justify-between gap-4 rounded-full bg-white px-6 py-4 font-semibold text-[color:var(--navy)] transition-transform active:scale-[0.97]">
              Personal anfragen <ArrowRight size={18} className="transition-transform group-hover:translate-x-1" />
            </Link>
            <Link to="/bewerber-registrierung" data-testid="cta-band-register" className="group inline-flex items-center justify-between gap-4 rounded-full border border-white/40 px-6 py-4 font-semibold text-white transition-[background-color] hover:bg-white/10">
              Als Bewerber registrieren <ArrowRight size={18} className="transition-transform group-hover:translate-x-1" />
            </Link>
          </Reveal>
        </div>
      </div>
    </div>
  </section>
);
